// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_socials__5hhCt {
  padding: 12px 20px;
  background: rgb(117, 83, 240);
  border: 2px solid rgb(117, 83, 240);
  border-radius: 20px;
  margin-top: 8px;
  width: 100%;
}

.style_list__o3JFi {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
@media (min-height: 600px) {
  .style_list__o3JFi {
    gap: 12px;
  }
}
.style_list__item__A\\+-Xu {
  display: flex;
  align-items: center;
  padding: 2px 0;
  justify-content: space-between;
}
.style_list__item__part__4bRbs {
  font-weight: 500;
  color: rgb(255, 255, 255);
  flex: 2 1;
  justify-content: flex-start;
  display: flex;
  align-items: center;
  gap: 8px;
}
.style_list__item__part__right__Fk4Mw {
  display: flex;
  flex: 1 1;
  justify-content: flex-start;
}
.style_list__item__part__4bRbs i {
  color: rgb(213, 212, 220);
}

.style_tasks__MXSdc {
  display: flex;
  flex-direction: column;
}

.style_task__ZF88G {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: rgb(255, 255, 255);
  font-size: 1.6rem;
  padding: 8px 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/profile/socials/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,6BCJK;EDKL,mCAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AADF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAAF;AACE;EAJF;IAKI,SAAA;EAEF;AACF;AADE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,8BAAA;AAGJ;AAFI;EACE,gBAAA;EACA,yBCnBE;EDoBF,SAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAIN;AAHM;EACE,aAAA;EACA,SAAA;EACA,2BAAA;AAKR;AAHM;EACE,yBC9BK;ADmCb;;AACA;EACE,aAAA;EACA,sBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBC9CM;ED+CN,iBAAA;EACA,cAAA;AAEF","sourcesContent":["@import 'public/assets/colors';\n\n.socials {\n  padding: 12px 20px;\n  background: $main;\n  border: 2px solid $main;\n  border-radius: 20px;\n  margin-top: 8px;\n  width: 100%;\n}\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  @media (min-height: 600px) {\n    gap: 12px;\n  }\n  &__item {\n    display: flex;\n    align-items: center;\n    padding: 2px 0;\n    justify-content: space-between;\n    &__part {\n      font-weight: 500;\n      color: $white;\n      flex: 2;\n      justify-content: flex-start;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      &__right {\n        display: flex;\n        flex: 1;\n        justify-content: flex-start;\n      }\n      i {\n        color: $light-grey;\n      }\n    }\n  }\n}\n\n.tasks {\n  display: flex;\n  flex-direction: column;\n}\n\n.task {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: $white;\n  font-size: 1.6rem;\n  padding: 8px 0;\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"socials": `style_socials__5hhCt`,
	"list": `style_list__o3JFi`,
	"list__item": `style_list__item__A+-Xu`,
	"list__item__part": `style_list__item__part__4bRbs`,
	"list__item__part__right": `style_list__item__part__right__Fk4Mw`,
	"tasks": `style_tasks__MXSdc`,
	"task": `style_task__ZF88G`
};
export default ___CSS_LOADER_EXPORT___;
